<div *ngIf="address && address.postalCode" class="address">
    <div class="headline">Adresse</div>
    <div class="line">{{ name }}</div>
    <div class="line">{{ getFirstLineOfAddress() }}</div>
    <div class="line">{{ getSecondLineOfAddress() }}</div>
</div>